import {useContext, useEffect} from 'react';
import styled from 'styled-components';
import {HiOutlineVideoCamera as VideoIcon} from 'react-icons/hi';
import {WSState} from '../providers/WebSocketProvider';
import {VideoState} from '../providers/VideoProvider';
import {ModalState} from '../providers/ModalProvider';

const Player = styled.div`
  height: 200px;
  width: 200px;
  border-radius: 50%;
  margin: auto;
  background: ${({ theme }) => theme && theme.background ? theme.background.overlay: 'none'};
  padding: ${({ inCall }) => !inCall ? '3.5rem' : '0'};

  & video {
    border-radius: 50%;
    display: ${({ inCall }) => !inCall ? 'none' : 'block'};
  }

  & svg {
    display: ${({ inCall }) => inCall ? 'none' : 'block'};
  }

  @media screen and (min-width: 768px) {
    margin: 0;
  }
`;

const VideoCmp = () => {
  //videoCmp
  const {state: wsState, dispatch: wsDispatch} = useContext(WSState);
  const {state: vState, dispatch: vDispatch} = useContext(VideoState);
  const {dispatch: modalDispatch} = useContext(ModalState);
  
  const inCall = vState ? vState.inCall : null;
  const showInvitation = wsState ? wsState.showInvitation : null;
  const fullName = wsState ? wsState.fullName : null;

  const handleStartCall = () => {
    vDispatch({type: 'connect'});
  };

  const answerInvitation = ({isAccepted}) => {
    if (isAccepted) handleStartCall();

    modalDispatch({ type: 'close' });
    
    wsDispatch({
      type: 'answer-invitation',
      isAccepted: isAccepted,
    });
  };

  const actions = [
    {text: "Accept", handler: () => answerInvitation({isAccepted: true}), type: "success"},
    {text: "Deny", handler: () => answerInvitation({isAccepted: false}), type: "danger"},
  ];

  useEffect(() => {
    if (showInvitation) {
      modalDispatch({
        type: 'openOptions',
        title: `Hello ${fullName},`,
        message: 'The host has invited you to join with audio.',
        actions: actions,
      })
    }
  }, [showInvitation])

  return (
    <>
      <Player id="player" inCall={inCall}>
        <VideoIcon size={100} color="#a3a3a3" />
      </Player>
    </>
  );
};

export default VideoCmp;
